import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';

import '../styles/wifi_view.scss';
import '../styles/inline_fallback.scss';
import '../styles/twitter_fallback.scss';

class TwitterFallback extends React.Component{

	render(){
		return (<div className="wifi-view twitter_fallback">
			

			<div className="arrow-twitter-icon">
				<Iconset.arrowIcon />
			</div>

			<div className="wifi-view-holder">
				<div className="logo-icon">
					<Iconset.logo />
				</div>
				<div className="wifi-view-block">
					<div className="ico cellular">
						<Iconset.sadSmiley />
					</div>
					<p>The Twitter in-app browser doesn't support the Blossomentary. Please open in Safari by clicking the arrow on the top right corner or on your computer.</p>
				</div>
			</div>
		</div>);
	}
}

export default TwitterFallback;


// WEBPACK FOOTER //
// ./src/scripts/twitter_fallback.js